import { getAllCustomers, getUnassociatedClients, updateCustomer, addCustomer, deleteCustomer } from '@/api/divy-customers';
const businessUnits = {
  namespaced: true,
  state: () => ({ Customer: null, Status: '', OpenModal: '', Clients: [] }),
  getters: {},
  actions: {
    updateOpenModal({ commit }, payload) {
      commit('SET_OPEN_MODAL', payload);
    },
    getCustomers({ commit }, payload) {
      return getAllCustomers(payload);
    },
    getClients({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getUnassociatedClients(payload)
          .then((Clients) => {
            commit('SET_CLIENTS', Clients);
          })
          .catch(() => {
            console.log('error occured from Business Unit store');
          });
      });
    },
    setCustomer({ commit }, payload) {
      commit('SET_CUSTOMER', payload);
    },
    updateCustomer({ commit }, payload) {
      commit('SET_STATUS', 'saving');
      return new Promise((resolve, reject) => {
        updateCustomer(payload)
          .then(() => {
            commit('SET_STATUS', '');
            resolve();
          })
          .catch((e) => {
            console.log('error occured from Business Unit store');
          });
      });
    },
    addCustomer({ commit }, payload) {
      commit('SET_STATUS', 'saving');
      return new Promise((resolve, reject) => {
        addCustomer(payload)
          .then(() => {
            commit('SET_STATUS', '');
            resolve();
          })
          .catch((e) => {
            console.log('error occured from Business Unit store');
          });
      });
    },
    deleteCustomer({ commit }, payload) {
      commit('SET_STATUS', 'saving');
      return new Promise((resolve, reject) => {
        deleteCustomer(payload)
          .then(() => {
            commit('SET_STATUS', '');
            resolve();
          })
          .catch((e) => {
            console.log('error occured from Business Unit store');
          });
      });
    },
  },

  mutations: {
    SET_CLIENTS: (state, Clients) => {
      state.Clients = Clients?.length > 0 ? Clients : [];
    },
    SET_CUSTOMER: (state, Customer) => {
      state.Customer = Customer;
    },
    SET_STATUS: (state, Status) => {
      state.Status = Status;
    },
    SET_OPEN_MODAL: (state, OpenModal) => (state.OpenModal = OpenModal),
  },
};

export default businessUnits;
